module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "width": "95%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarInclusao),
      expression: "mostrarInclusao"
    }],
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "form-horizontal box-body well well-sm"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('arquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": "arquivo"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('descricao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Nome do " + _vm._s(_vm.tipoDocumento) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descricao),
      expression: "descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "descricao"
    },
    domProps: {
      "value": (_vm.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descricao = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Após clicar no OK, esse " + _vm._s(_vm.tipoDocumento) + " estará público para download")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarInclusao),
      expression: "!mostrarInclusao"
    }],
    staticClass: "row box-header"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mostrarInclusao = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo " + _vm._s(_vm.tipoDocumento) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabela.filter),
      expression: "tabela.filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": 'Pesquise ' + _vm.tipoDocumento + '...'
    },
    domProps: {
      "value": (_vm.tabela.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tabela, "filter", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarInclusao),
      expression: "!mostrarInclusao"
    }],
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "how-empty": "",
      "stacked": "md",
      "bordered": _vm.tabela.bordered,
      "items": _vm.tabela.items,
      "hover": _vm.tabela.hover,
      "fields": _vm.tabela.fields,
      "filter": _vm.tabela.filter,
      "current-page": _vm.tabela.currentPage,
      "per-page": _vm.tabela.perPage,
      "sort-by": _vm.tabela.sortBy,
      "sort-desc": _vm.tabela.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabela, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabela, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabela, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabela, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "link",
      fn: function(row) {
        return [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.descricao))])]
      }
    }, {
      key: "data",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.item.dt_data_emissao, "L")))]
      }
    }, (_vm.usuarioLogado.userType === 'FUNDACAO') ? {
      key: "actions",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.excluirDocumento(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Excluir")])]
      }
    } : null], null, true)
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56e2df6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ged/documentosPorTipo.vue
// module id = 1871
// module chunks = 2